import ContactForm from "./components/contactForm";
import { useTranslation } from "react-i18next";

function ContactPage() {
  const { t } = useTranslation("global");
  
  return (
    <>
      {/* Hero Section with 3D Tailwind Design */}
      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col-reverse md:flex-row md:items-center md:justify-between gap-8">
            <div className="md:w-1/2 space-y-6">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-black">
                {t("contact.contact")}
              </h1>
              <p className="text-lg text-gray-600 max-w-xl">
                {t("contact.text")}
              </p>
              <div className="w-20 h-1 bg-blue-600"></div>
            </div>
            
            <div className="md:w-1/2 flex justify-center">
              {/* 3D Contact Design using Tailwind */}
              <div className="relative w-80 h-80 perspective-1000">
                {/* Background blobs */}
                <div className="absolute w-64 h-64 bg-blue-100 rounded-full -top-10 -right-10 opacity-40"></div>
                <div className="absolute w-40 h-40 bg-indigo-100 rounded-full bottom-4 -left-8 opacity-50"></div>
                
                {/* 3D Envelope */}
                <div className="absolute inset-0 flex items-center justify-center transform rotate-6 hover:rotate-0 transition-transform duration-500">
                  <div className="w-64 h-48 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg shadow-xl transform rotate-y-12 rotate-x-6 relative overflow-hidden">
                    {/* Envelope flap */}
                    <div className="absolute top-0 left-0 w-full h-24 bg-blue-400 origin-bottom transform -rotate-x-30">
                      <div className="absolute bottom-0 left-0 w-full h-6 bg-blue-500 opacity-30"></div>
                    </div>
                    
                    {/* Message paper */}
                    <div className="absolute top-6 left-4 right-4 bottom-4 bg-white rounded-md shadow-inner transform translate-z-2 flex flex-col items-center justify-center p-4">
                      <div className="w-full h-2 bg-gray-200 rounded-full mb-2"></div>
                      <div className="w-3/4 h-2 bg-gray-200 rounded-full mb-2"></div>
                      <div className="w-full h-2 bg-gray-200 rounded-full mb-2"></div>
                      <div className="w-5/6 h-2 bg-gray-200 rounded-full mb-2"></div>
                      <div className="w-4/5 h-2 bg-gray-200 rounded-full"></div>
                    </div>
                  </div>
                </div>
                
                {/* Floating contact symbols */}
                <div className="absolute top-12 -right-4 w-16 h-16 bg-white rounded-full shadow-lg flex items-center justify-center transform hover:scale-110 transition-transform">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                
                <div className="absolute bottom-20 -left-4 w-14 h-14 bg-white rounded-full shadow-lg flex items-center justify-center transform hover:scale-110 transition-transform">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                
                <div className="absolute top-32 left-0 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center transform hover:scale-110 transition-transform">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Contact Form Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-black mb-4">
              {t("contact.ways")}
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              {t("contactForm.formtext")}
            </p>
            <div className="w-20 h-1 bg-blue-600 mx-auto mt-4"></div>
          </div>
          
          <div className="max-w-5xl mx-auto">
            <ContactForm />
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="py-12 bg-blue-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold mb-4">
            {t("contact.needHelp", "Besoin d'aide supplémentaire?")}
          </h2>
          <p className="text-blue-100 max-w-2xl mx-auto mb-8">
            {t("contact.helpText", "Notre équipe d'experts est à votre disposition pour répondre à toutes vos questions sur nos services d'évaluation de conformité.")}
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="faq"
              className="bg-white text-blue-800 hover:bg-blue-100 py-3 px-8 rounded-full font-heading font-bold transition-all"
            >
              {t("FAQ.title")}
            </a>
            <a
              href="demo"
              className="bg-transparent border-2 border-white text-white hover:bg-white/10 py-3 px-8 rounded-full font-heading font-bold transition-all"
            >
              {t("header.demo")}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactPage;